import { render, staticRenderFns } from "./detection_rules.vue?vue&type=template&id=0c17d6a2&scoped=true&"
import script from "./detection_rules.vue?vue&type=script&lang=js&"
export * from "./detection_rules.vue?vue&type=script&lang=js&"
import style0 from "./detection_rules.vue?vue&type=style&index=0&id=0c17d6a2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c17d6a2",
  null
  
)

export default component.exports